import { Injectable, ViewChild, ElementRef } from '@angular/core';
import { UserService } from '../services/user.service';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse, } from "@angular/common/http";
//import { jsPDF } from 'jspdf';
import { BehaviorSubject, forkJoin, Observable, throwError } from 'rxjs';
import { Epk } from '../profile/epk';
import { catchError, map } from 'rxjs/operators';
import { GlobalService } from '../services/global.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  headers = new HttpHeaders().set("Authorization", this.user.token);
  ;
   baseUrl = "https://sdapi.songdew.com/apis";
//  baseUrl: String = "http://164.52.200.19:8000/apis"
  epk$ = new BehaviorSubject<Epk[]>(null);
  userData$ = this.epk$.asObservable();
  public slug = '';
  public profileStatus: Boolean;


  // public printing: Boolean = true;
  // public printAchivements: Boolean = true;
  // public printPhotos: Boolean = true;
  // public printQuotes: Boolean = true;
  // public printLiveperformance: Boolean = true;
  // public printInPress: Boolean = true;
  // public printAssets: Boolean = true;
  // public printMusic: Boolean = true;
  // public printVideo: Boolean = true;
  // public printstory: Boolean = true;
  // public printenquiry: Boolean = true;

  // public achivementsComplete: Boolean = true;
  // public storyComplete: Boolean = true;
  // public photosComplete: Boolean = true;
  // public quotesComplete: Boolean = true;
  // public liveperformanceComplete: Boolean = true;
  // public pressComplete: Boolean = true;
  // public musicComplete: Boolean = true;
  // public videoComplete: Boolean = true;
  public enquiriesSection: boolean = true;

  // baseUrl = "https://orbit.songdew.com/apis";
  //  baseUrl: String = "http://164.52.200.19:8000/apis";


  constructor(private http: HttpClient, private user: UserService, private global: GlobalService, private router: Router) {

  }

  public imgCdn = "";
  public coverimgCdn = '';
  
  public tooltip = [
    { id: 0, section: "all", text: "Show/hide a section", position: 'above' },
    { id: 1, section: "all", text: "Edit a section", position: 'above' },
    { id: 2, section: "top", text: "Banner to show your creativity- Upload your own or choose from the ones available", position: 'above' },
    { id: 3, section: "top", text: "Display Pic- show the world the face of new music superstar", position: 'above' },
    { id: 4, section: "top", text: "Name:AKA-what others will call you", position: 'above' },
    { id: 5, section: "top", text: "What is your performance category? Choose multiple if you multitask :)", position: 'above' },
    { id: 6, section: "top", text: "Your Location - Let others know where you are from", position: 'above' },
    { id: 7, section: "top", text: "Show how you want to collaborate with  the world around you", position: 'above' },
    { id: 8, section: "story", text: "Let others connect with you at personal level by sharing who you are", position: 'above' },
    { id: 9, section: "story", text: "Write the story about you that you want others to know", position: 'above' },
    { id: 10, section: "story", text: "Select the languages/languages that you create music and videos", position: 'above' },
    { id: 11, section: "story", text: "Select Genre/Genres you perform", position: 'above' },
    { id: 12, section: "story", text: "Add your band members", position: 'above' },
    { id: 13, section: "story", text: "Add video/image to share your story with others ", position: 'above' },
    { id: 14, section: "achievements", text: "Add past achievements that you are proud of", position: 'above' },
    { id: 15, section: "rebenq", text: "Show how you want to collaborate with the world around you", position: 'above' },
    { id: 16, section: "music", text: "Highlight your best music", position: 'above' },
    { id: 17, section: "music", text: "Add tracks you created", position: 'above' },
    { id: 18, section: "video", text: "Add videos you created ", position: 'above' },
    { id: 19, section: "quote", text: "Add your favorite quotes ", position: 'above' },
    { id: 20, section: "livePer", text: "Add past performances you did", position: 'above' },
    { id: 21, section: "assets", text: "Upload files others can download", position: 'above' },
    { id: 22, section: "top", text: "Social presence – your profiles for others to follow you", position: 'above' },
    { id: 23, section: "photo", text: "Add your photos", position: 'above' },
    { id: 24, section: "inpress", text: "Add your press release", position: 'above' },
   { id: 25, section: "all", text: "A logo that represents your artist or brand name in a unique font or style.", position: 'above' },
    { id: 26, section: "all", text: "Your technical requirements for a smooth live performance, such as sound setup, backline instruments, stage plot, lighting, power needs, etc.", position: 'below' },


  ]




  userProfileDetails() {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    this.http.get<Epk[]>(this.baseUrl + "/profile/v2/user_details/?user_slug=" + this.slug, {
      headers: headers,

    })
      .subscribe((res) => {
        // console.log(res)
        this.epk$.next(res)

      }, (error: HttpErrorResponse) => {
        console.error('User not found');
        if (error.status == 500) {
          this.router.navigate(['/404']);
        }
      })
  }

  getCountry() {
    const headers = new HttpHeaders().set("Authorization", this.user.token);

    const url = this.baseUrl + "/country/"
    return this.http.get(url, {
      headers: headers,
    })
  }

  enquiry() {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    const url = this.baseUrl + "/profile/enquiry/?user_slug=" + this.slug
    return this.http.get(url, {
      headers: headers,
    })

  }


  get<T>(path: string, params?: HttpParams, headers?: HttpHeaders): Observable<T> {
    return this.http.get<T>(this.baseUrl + path, { params, headers }).pipe(
      catchError(this.handleError)
    );
  }

  post<T>(path: string, body: any, params?: HttpParams, headers: HttpHeaders = this.headers): Observable<T> {
    return this.http.post<T>(this.baseUrl + path, body, { params, headers }).pipe(
      catchError(this.handleError)
    );
  }



  put<T>(path: string, body: any, params?: HttpParams, headers: HttpHeaders = this.headers): Observable<T> {
    return this.http.put<T>(this.baseUrl + path, body, { params, headers }).pipe(
      catchError(this.handleError)
    );
  }


  delete<T>(path: string, params?: HttpParams, headers: HttpHeaders = this.headers): Observable<T> {
    return this.http.delete<T>(this.baseUrl + path, { params, headers }).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    // You can customize error handling based on your application's needs
    let errorMessage = 'An error occurred.';
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = error.error.message;
    } else {
      // Server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(() => error)
  }





  downloadFile(url): any {
    return this.http.get(url, { responseType: 'blob' });
  }


}



